/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelLateRoute.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/late-route";

export class AutogenModelLateRoute<RowType extends ModelRow> extends Endpoint<RowType, RowLateRouteFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowLateRoute extends ModelRow<RowLateRouteFields> {
	constructor(values?: Partial<RowLateRouteFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowLateRouteFields {
	actual_depart: string;
	callin_id: string;
	company_id: string;
	creation_date: Date;
	creation_source: string;
	depart_date: Date;
	distancetostop: number;
	distancetostop_um: string;
	driver_id: string;
	driver_load_unload: string;
	first_occur: string;
	hours_to_8hrbreak: number;
	id: string;
	in_zone_id: string;
	is_current: string;
	late_route_status: string;
	mc_position_id: string;
	movement_id: string;
	next_stop_id: string;
	nonstop_eta: Date;
	oor_distance: number;
	oor_distance_um: string;
	order_id: string;
	out_zone_id: string;
	percent_oor: number;
	planned_arrival: Date;
	previous_stop_id: string;
	projected_arrival: Date;
	projected_lateflag: string;
	projected_oorflag: string;
	straight_eta: Date;
	team_drivers: string;
	tractor_id: string;
	trailer_id: string;
	travel_time: number;
	unload_time: number;
	weather_notice_url: string;
}

